/**
 * Created by intellicar-rinas on 21/10/17.
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import "./InGraph.css";
import * as d3 from "d3";
import moment from "moment";
import actions from "../../../../store/actions";
import _ from "lodash";
import {
  dateFormat,
  graphOffsetKey,
  dateFormatWithSec,
} from "../../../../constants/constants";
import isGraphVisible from "../../../../Layouts/config/reports/historyReport/graphVisibilityConfig";
import $ from "jquery";

class InGraph2 extends Component {
  state = {
    busy: false,
    popup: {
      style: {
        // display:
      },
    },
  };

  data = {};
  barGraphsHeight = 4;
  currentDataObject = {};

  constructor(props) {
    super(props);

    [
      "draw",
      "initSVG",
      "drawAxis",
      "drawPath",
      "checkIsDataValid",
      "setDomains",
      "clearSVG",
      "initDefs",
      "setDimensions",
      "setAxis",
      "saveGraphData",
      "getGraphData",
      "renderZoomBlocker",
      "renderNoDataBox",
      "renderBusyBox",
      "renderSVG",
      "getMargin",
      "calculateDomainValues",
      "getTickValues",
      "getYAxis",
      "setLine",
      "getLastGraphData",
      "resizeGraph",
      "getStrokeColor",
      "addListenerToGraph",
      "mouseOverTrigger",
      "mouseDownTrigger",
      "mouseUpTrigger",
      "mouseLeaveTrigger",
      "mouseClickTrigger",
      "setCurrentXY",
      "drawPointerLineAndText",
      "getGraphConfig",
      "getPointerLineText",
      "setCurrentDataObject",
      "getCurrentDataObjects",
      "getMultiLineName",
      "setPointerLineAndText",
      "onMouseOver",
      "broadCastMouseOverEvent",
      "isMouseDownValid",
      "onZoom",
      "getDrawConfig",
      "getDrawZoomConfig",
      "togglePointerLock",
      "broadCastPointerLockEvent",
      "onPointerLock",
      "broadCastDataForOldGraphListeners",
      "onSetTimeLine",
      "toggleGraphLine",
      "drawShapes",
      "drawBarGraph",
      "drawDotGraph",
      "setBarGraphData",
      "setDotGraphData",
      "onDotGraphClick",
      "drawLegends",
      "onKeyDown",
      "broadCastGotoEvent",
      "getData",
    ].map((i) => (this[i] = this[i].bind(this)));

    this.uid = "InGraph-" + parseInt(Math.random() * 100000000, 10);

    window.addEventListener("resize", () => {
      clearTimeout(this.resizeDebounce);
      this.resizeDebounce = setTimeout(() => {
        this.resizeGraph();
      }, 500);
    });

    window.addOnSaveVehicleStateListener(
      "InGraph-" + this.props.data.key,
      this.onVehicleChange
    );
  }

  componentDidMount() {
    if (this.props.resume && this.props.resume.state) {
      for (let idx in this.props.resume.state) {
        this[idx] = this.props.resume.state[idx];
      }
      if (this.data && Object.keys(this.data).length) {
        this.draw();
      }
    }
    this.props.data._ref = {
      draw: this.background_draw,
      setBarGraphData: this.background_setBarGraphData,
      setDotGraphData: this.background_setDotGraphData,
      setNoData: this.background_setNoData,
      setBusy: this.background_setBusy,
      getData: this.getData,
      props: { ...this.props },
    };
    this.registerListeners(this.props);
  }

  registerListeners = (props) => {
    window.addInGraph2Listener(
      "mouseover",
      this.uid,
      this.onMouseOver,
      props.data.graphSetName
    );
    window.addInGraph2Listener(
      "zoom",
      this.uid,
      this.onZoom,
      props.data.graphSetName
    );
    window.addInGraph2Listener(
      "pointerlock",
      this.uid,
      this.onPointerLock,
      props.data.graphSetName
    );
    window.addEventListener("keydown", this.onKeyDown);
    if (props.data.controller) {
      window.addInGraph2Listener(
        "settimeline",
        this.uid,
        this.onSetTimeLine,
        props.data.graphSetName
      );
    }
  };

  componentWillReceiveProps(props) {
    this.saveState();
    if (props.data.key !== this.props.data.key) {
      this.registerListeners(props);
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
    this.saveState();
  }

  saveState = () => {
    if (this.props.saveState) {
      this.props.saveState(
        {
          state: this.state,
          data: this.data,
          lastGraphData: this.lastGraphData,
          drawConfig: this.drawConfig,
          shapes: this.shapes,
          barGraphs: this.barGraphs,
          dotGraphs: this.dotGraphs,
          drawZoomConfig: this.drawZoomConfig,
        },
        this.props.schemaKey,
        this.props.data
      );
    }
  };

  /*
   *
   *   Background Functions
   *
   * */

  background_draw = (
    args = this.getLastGraphData(),
    drawConfig = this.getDrawZoomConfig(),
    key,
    graphKey
  ) => {
    if (!this.checkIsDataValid(args)) {
      return;
    }

    if (
      args.data &&
      args.data[0] &&
      args.data[0].filter((i) => {
        // for (let idx in i) {
          if (i == null) return;
        // }
        return true;
      }).length !== args.data[0].length
    )
      return;

    this.saveGraphData(args, drawConfig,key,graphKey);
    this.saveState();
    if(graphKey === "gpsspeed")this.draw(args,drawConfig,key,graphKey)
  };

  background_setBarGraphData = (data = []) => {
    this.setBarGraphData(data);
    this.saveState();
  };

  background_setDotGraphData = (data = []) => {
    this.setDotGraphData(data);
    this.saveState();
  };

  background_setNoData = (state) => {
    this.state.noData = state;

    this.data = {};
    this.lastGraphData = {};
    this.drawConfig = {};
    this.shapes = [];
    this.barGraphs = [];
    this.dotGraphs = [];
    this.drawZoomConfig = {};

    this.saveState();
  };

  background_setBusy = (state) => {
    this.state.busy = state;
    this.saveState();
  };

  /*
   *
   *   Draw
   *
   * */

  draw(
    args = this.getLastGraphData(),
    drawConfig = this.getDrawZoomConfig(),
    key,
    graphKey
  ) {

    if (!this.checkIsDataValid(args) || !this.refs || !this.refs.svg) {
      return;
    }

    this.saveGraphData(args, drawConfig, key, graphKey);
    this.setDimensions(args);
    this.calculateDomainValues(args, drawConfig);
    this.setDomains(args);
    this.setAxis(args);
    this.setLine(args);
    this.initSVG(args);
    this.clearSVG(args);
    setTimeout(() => {
      this.initDefs(args);
      this.drawPath(args, key, graphKey);
      this.drawShapes();
      this.drawAxis(args);
      this.addListenerToGraph(args);
      this.drawPointerLineAndText(args);
      this.drawLinePoints(args);
      this.drawBarGraph(args);
      this.drawDotGraph(args);
      this.drawLegends(args);
      this.setBusy(false);
    }, 50);
  }

  checkIsDataValid(args) {
    if (args && args.data && args.data[0] && args.data[0].length) {
      this.setNoData(false);
    } else {
      this.setNoData(true);
      return false;
    }

    let reqTime = args.reqTime;
    let priority = args.priority;

    if (this.data[args.axis]) {
      if (
        reqTime !== this.data[args.axis].lastReqTime ||
        priority >= this.data[args.axis].priority
      ) {
        return true;
      }
      return false;
    }
    return true;
    // return !(this.data[args.axis] && reqTime === this.data[args.axis].lastReqTime && priority < this.data[args.axis].priority);
  }

  setBarGraphData(data = []) {
    this.barGraphs = data;
  }

  setDotGraphData(data = []) {
    this.dotGraphs = data;
  }

  saveGraphData(args, drawConfig = {}, key, graphKey) {
    this.graphKey = graphKey;
    this.data[args.axis] = { ...args };
    this.lastGraphData = { ...args };
    if (!drawConfig.zoomConfig) {
      this.drawConfig = { ...drawConfig };
      this.shapes = drawConfig.shapes;
      if ("barGraph" in drawConfig) {
        this.barGraphs = drawConfig.barGraphs;
      }
      if ("dotGraphs" in drawConfig) {
        this.dotGraphs = drawConfig.dotGraphs;
      }
    }
    if (drawConfig.barChart) {
      this.props.data.barChart = { ...drawConfig.barChart };
    }
    this.drawZoomConfig = { ...drawConfig };
  }

  getGraphData(axis = false) {
    return this.data[axis] || { data: [] };
  }

  getGraphConfig(axis = false) {
    return this.props.lines[axis] || { data: [] };
  }

  getGraphName(idx) {
    let fueltype =
      window.selectedVehicles &&
      window.selectedVehicles[0] &&
      window.selectedVehicles[0].data.vehicleModel.fueltype;
    if (this.getGraphConfig(idx).name === "Fuel" && fueltype === "EV") {
      return "SoC";
    } else if (
      this.getGraphConfig(idx).name === "Engine Speed" &&
      fueltype === "EV"
    ) {
      return "RPM";
    } else {
      return this.getGraphConfig(idx).name;
    }
  }
  getDrawConfig() {
    return this.drawConfig || {};
  }

  getDrawZoomConfig() {
    return this.drawZoomConfig || {};
  }

  setNoData(noData) {
    if (this.unmounted) return;

    if (noData) {
      this.data = {};
      this.lastGraphData = {};
      this.drawConfig = {};
      this.shapes = [];
      this.barGraphs = [];
      this.dotGraphs = [];
      this.drawZoomConfig = {};
      this.clearSVG();
    }

    this.setState({ noData, busy: false });
  }

  setBusy(busy) {
    if (this.unmounted) return;
    this.setState({ busy });
  }

  getMargin() {
    if (this.props.config.type !== "controller") {
      return {
        top: 20,
        // right: 20 + ((this.props.lines.length -1) * 25 ),
        right: 40,
        bottom: 20,
        left: 40,
      };
    } else {
      return {
        top: 1,
        right: 1,
        bottom: 25,
        left: 1,
      };
    }
  }

  getLastGraphData() {
    return this.lastGraphData;
  }

  setDimensions() {
    this.margin = this.getMargin();
    this.width = this.props.config.width - this.margin.left - this.margin.right;
    this.height =
      this.props.config.height -
      this.margin.bottom -
      this.margin.top -
      (this.props.data.wrapper ? 30 : 0);
  }

  calculateDomainValues(args, drawConfig) {
    if (drawConfig.xDomainValue && drawConfig.xDomainValue.length === 2) {
      this.xDomainValue = drawConfig.xDomainValue;
    } else {
      this.xDomainValue = d3.extent(args.data, (d) => {
        return d.time;
      });
    }

    this.yDomainValue = {};
    for (let idx in this.props.lines) {
      let config = this.getGraphConfig(idx);
      if (drawConfig.yDomainValue && drawConfig.yDomainValue.length === 2) {
        this.yDomainValue[idx] = config.yScale = drawConfig.yDomainValue;
      } else if (config.yScale) {
        this.yDomainValue[idx] = config.yScale;
      } else {
        let data = this.getGraphData(idx).data || [];
        let dataSet = [];
        for (let jdx in data) {
          dataSet = [...dataSet, ...data[jdx]];
        }
        this.yDomainValue[idx] = d3.extent(dataSet, (d) => {
          return d.value;
        });
        if (!this.props.lines[idx].normalize) {
          if (
            this.props.data.key === "battery_current" ||
            this.props.data.key === "temperature"
          ) {
          } else this.yDomainValue[idx][0] = 0;
        }
        if (this.yDomainValue[idx][1]) {
          this.yDomainValue[idx][1] =
            this.yDomainValue[idx][1] +
            (this.yDomainValue[idx][1] - this.yDomainValue[idx][0]) * 0.7;
        }
      }
    }
  }

  setDomains() {
    if (this.props.data.xAxis === "odometer") {
      this.xDomain = d3
        .scaleLinear()
        .range([0, this.width])
        .domain(this.xDomainValue);
    } else {
      this.xDomain = d3
        .scaleTime()
        .range([0, this.width])
        .domain(this.xDomainValue);
    }
    this.yDomain = {};
    for (let idx in this.props.lines) {
      this.yDomain[idx] = d3
        .scaleLinear()
        .range([this.height, 0])
        .domain(this.yDomainValue[idx]);
    }
  }

  getTickValues(d) {
    if (d > 9990) {
      return parseInt(d / 1000, 10) + "k";
    } else if (d > 999) {
      return (d / 1000).toFixed(2) + "k";
    }
    return d;
  }

  getYAxis(index) {
    return index % 2 === 0 ? d3.axisLeft : d3.axisRight;
  }

  setAxis() {
    this.xAxis = d3.axisBottom(this.xDomain).ticks(this.props.data.ticks || 3);
    this.yAxis = {};
    let yAxisCounter = 0;
    for (let idx in this.props.lines) {
      this.yAxis[idx] = this.getYAxis(yAxisCounter)(this.yDomain[idx])
        .ticks(5)
        .tickFormat(this.getTickValues);
      yAxisCounter++;
    }
  }

  setLine() {
    this.line = {};
    for (let idx in this.props.lines) {
      this.line[idx] = d3
        .line()
        .x((d) => {
          return this.xDomain(d.time);
        })
        .y((d) => {
          return this.yDomain[idx](d.value);
        });

      if (!this.props.data.disableSmoothing) {
        this.line[idx].curve(d3.curveMonotoneX);
      }
    }
  }

  initSVG() {
    if (this.refs.svg) {
      this.svg = d3.select(this.refs.svg);
      this.svg.on("contextmenu", function (d) {
        // d3.event.preventDefault();
      });
    }
  }

  resizeGraph() {
    this.draw();
  }

  clearSVG() {
    if (this.svg) {
      this.svg.selectAll("*").remove();
    }
  }

  initDefs() {
    if (this.svg) {
      this.defs = this.svg.append("defs");
      this.defs
        .append("clipPath")
        .attr("id", "clip-" + this.uid)
        .append("rect")
        .attr("width", this.width)
        .attr("height", this.height);

      this.pathgrad = this.defs
        .append("linearGradient")
        .attr("id", "pathgrad")
        .attr("x1", "50%")
        .attr("y1", "100%")
        .attr("x2", "50%")
        .attr("y2", "0%");

      this.pathgrad
        .append("stop")
        .attr("offset", "0%")
        .attr("style", "stop-color:rgb(153,218,255);stop-opacity:1");

      this.pathgrad
        .append("stop")
        .attr("offset", "100%")
        .attr("style", "stop-color:rgb(0,255,60);stop-opacity:1");

      this.focus = this.svg
        .append("g")
        .attr("class", "focus")
        .attr(
          "transform",
          "translate(" + this.margin.left + "," + this.margin.top + ")"
        );

      this.Context = this.svg
        .append("g")
        .attr("class", "context")
        .attr(
          "transform",
          "translate(" + this.margin.left + "," + this.margin.top + ")"
        );
    }
  }

  drawAxis() {
    if (this.focus) {
      this.focus
        .append("g")
        .attr("class", "axis axis--x")
        .attr("transform", "translate(0," + this.height + ")")
        .call(this.xAxis);

      let axisIndex = 0;
      for (let idx in this.yAxis) {
        if (this.getGraphConfig(idx).disabled) {
          axisIndex++;
          continue;
        }

        this.focus
          .append("g")
          .attr("class", "axis axis--y")
          .attr(
            "transform",
            "translate(" + (axisIndex === 0 ? 0 : this.width) + ",0)"
          )
          .call(this.yAxis[idx]);
        axisIndex++;
      }
    }
  }

  getStrokeColor(axis) {
    return this.props.lines[axis].disabled
      ? "#888"
      : this.props.lines[axis].color;
  }

  drawPath(args, key, graphKey) {
    if (this.focus) {
      for (let idx in this.line) {
        if (this.getGraphConfig(idx).disabled) continue;
        let dataSet = this.getGraphData(idx).data;
        if (
          this.props.data.barChart &&
          this.props.data.barChart.enabled &&
          this.props.data.barChart.bucketSize
        ) {
          this.drawBarChart(dataSet, {
            axis: parseInt(idx),
            graphConfig: this.getGraphConfig(idx),
          });
        } else {
          for (let jdx in dataSet) {
            this.focus
              .append("path")
              .data([dataSet[jdx]])
              .attr("stroke", this.getStrokeColor(idx, jdx))
              .attr("stroke-width", "2px")
              .attr("class", "area")
              .attr("clip-path", "url(#clip-" + this.uid + ")")
              .attr("d", this.line[idx]);
          }
        }
      }
    }
  }

  drawBar = (data, config) => {
    let width,
      height,
      x,
      y,
      offset = 0,
      maxWidth = 30;
    x = this.xDomain(data.time);
    y = this.yDomain[config.axis](data.value);
    height = y;
    width = this.xDomain(data.time + this.props.data.barChart.bucketSize) - x;

    if (width > maxWidth) {
      offset = (width - maxWidth) / 2;
      width = maxWidth;
    }

    if (!config.fullWidth) {
      width = width / this.props.lines.length;
      x += width * config.axis;
    }

    this.focus
      .append("rect")
      .attr("clip-path", "url(#clip-" + this.uid + ")")
      .attr("fill", config.color)
      .attr("x", offset + x)
      .attr("y", y)
      .attr("value", data.value)
      .attr("width", width)
      .attr("height", this.height - height);

    // if(config.stroke) {
    //     this.focus
    //         .attr("stroke", config.stroke)
    //         .attr("stroke-wdith", config.strokeWidth)
    // }
  };

  drawBarChart = (dataSet, config) => {
    let data,
      maxDataSet = {},
      color;

    for (let jdx in dataSet) {
      data = dataSet[jdx];
      for (let idx in data) {
        if (!maxDataSet[data[idx].time]) {
          maxDataSet[data[idx].time] = {
            time: data[idx].time,
            value: 0,
          };
        }
        if (data[idx].value > maxDataSet[data[idx].time].value) {
          maxDataSet[data[idx].time].value = data[idx].value;
        }
      }
    }

    for (let idx in maxDataSet) {
      this.drawBar(maxDataSet[idx], {
        color: "#eee",
        stroke: "#aaa",
        strokeWidth: 1,
        fullWidth: true,
        axis: 0,
      });
    }

    setTimeout(() => {
      for (let jdx in dataSet) {
        data = dataSet[jdx];
        color = this.getStrokeColor(config.axis, jdx);
        for (let idx in data) {
          this.drawBar(data[idx], { ...config, color });
        }
      }
    });
  };

  drawShapes() {
    if (this.shapes) {
      for (let idx in this.shapes) {
        let data = this.shapes[idx];
        if (data.type === "path") {
          this.focus
            .append("path")
            .data([data.data])
            .attr("stroke", data.stroke)
            .attr("fill", data.fill || "none")
            .attr("stroke-width", data.strokeWidth || "2px")
            .attr("stroke-opacity", data.strokeOpacity)
            .attr("clip-path", "url(#clip-" + this.uid + ")")
            .attr("d", this.line[data.axis]);
        }
      }
    }
  }

  drawLinePoints() {
    if (this.focus && this.props.data.dots) {
      for (let idx in this.line) {
        if (this.getGraphConfig(idx).disabled) continue;
        let dataSet = this.getGraphData(idx).data;
        for (let jdx in dataSet) {
          for (let kdx in dataSet[jdx]) {
            this.focus
              .append("circle")
              .attr("fill", this.getStrokeColor(idx, jdx))
              .attr("r", 2)
              .attr("cx", (d) => {
                return this.xDomain(dataSet[jdx][kdx].time);
              })
              .attr("cy", (d) => this.yDomain[idx](dataSet[jdx][kdx].value))
              .attr("class", "path-point");
          }
        }
      }
    }
  }

  drawPointerLineAndText() {
    if (this.focus) {
      let fueltype =
        window.selectedVehicles &&
        window.selectedVehicles[0] &&
        window.selectedVehicles[0].data.vehicleModel.fueltype;
      this.pointerLine = this.focus
        .append("rect")
        .attr("x", 0)
        .attr("y", 0)
        .attr("clip-path", "url(#clip-" + this.uid + ")")
        .attr("width", 2)
        .attr("class", "pointerLine")
        .attr("height", this.height)
        .attr("fill", "rgba(255,100,100,0.5)");

      for (let idx in this.line) {
        if (this.getGraphConfig(idx).name) {
          let marTop = [7, 17, 27, 37, 47];
          this["graphName" + idx] = this.svg
            .append("g")
            .attr("class", "graphName")
            .attr(
              "transform",
              "translate(" + this.margin.left + "," + marTop[idx] + ")"
            );

          // this['pointerText' + idx] = this.focus.append("text")
          this["pointerText" + idx] = this["graphName" + idx]
            .append("text")
            .attr("x", 23)
            .attr("y", 8)
            .attr("font-size", 10)
            .attr("font-family", "gotham-b")
            .attr("fill", this.getStrokeColor(idx) || "#6da7ff")
            // .text(this.getGraphConfig(idx).name === "Fuel" && fueltype === "EV" ? "SoC" : this.getGraphConfig(idx).name);
            .text(this.getGraphName(idx));

          this["pointerCheckBox" + idx] = this["graphName" + idx]
            .append("rect")
            .attr("x", 10)
            .attr("y", 1)
            .attr("width", 8)
            .attr("height", 8)
            .attr("fill-opacity", 0)
            .attr("stroke", this.getStrokeColor(idx))
            .attr("stroke-width", 1);

          if (!this.getGraphConfig(idx).disabled) {
            this["pointerCheckBox" + idx] = this["graphName" + idx]
              .append("rect")
              .attr("x", 12)
              .attr("y", 3)
              .attr("width", 4)
              .attr("height", 4)
              .attr("fill", this.getStrokeColor(idx));
          }

          this["pointerToggleRect" + idx] = this["graphName" + idx]
            .append("rect")
            .attr("x", 0)
            .attr("y", 0)
            .attr("width", this.width)
            .attr("height", 12)
            .attr("fill-opacity", 0)
            .on("click", () => this.toggleGraphLine(idx));
          // .attr("fill", this.getStrokeColor(idx) ||  '#6da7ff')
          // .text(this.getGraphConfig(idx).name)
        }
      }

      if (this.props.data.pointerTime) {
        this.textTime = this.svg
          .append("g")
          .attr("class", "graphName")
          .append("text")
          .attr("x", this.width - 70)
          .attr("y", this.margin.top + 8)
          .attr("font-size", 10)
          .attr("font-family", "gotham-b")
          .attr("fill", "#6da7ff");
      }
    }
  }

  setBarChartHeight = (height) => {
    this.barGraphsHeight = height;
  };

  openGraphPopup = (item, state = true) => {
    if (state == false) {
      this.setState({
        popup: {
          style: { opacity: 0 },
        },
      });
      return;
    }

    let data = JSON.parse(d3.select(item).attr("item-data"));
    let pos = $(item).offset();
    let parentPos = $(this.refs.container).offset();
    let left = pos.left - parentPos.left;
    let top = pos.top - parentPos.top;
    let parentHeight = $(this.refs.container).height();
    let parentWidth = $(this.refs.container).width();
    let clientHeight = $(this.refs.popup).height();
    let clientWidth = $(this.refs.popup).width();
    let itemHeight = $(item).height();
    let itemWidth = $(item).width();

    if (top > parentHeight / 2) {
      top = top - clientHeight;
    } else {
      top += itemHeight + 15;
    }
    if (left > parentWidth / 2) {
      left = left - clientWidth;
    }

    this.setState({
      popup: {
        style: { opacity: 1, left, top },
        name: data.name,
        content: data.content,
      },
    });
  };

  drawBarGraph() {
    if (this.barGraphs) {
      let openGraphPopup = this.openGraphPopup;
      for (let idx in this.barGraphs) {
        if (!this.barGraphs[idx] || !this.barGraphs[idx].data) continue;
        let barGraph = this.barGraphs[idx];
        for (let jdx in barGraph.data) {
          let barGraphItem = barGraph.data[jdx];
          let rect = this.svg
            .append("rect")
            .attr("x", this.xDomain(barGraphItem.left))
            .attr("clip-path", "url(#clip-" + this.uid + ")")
            .attr("item-data", JSON.stringify(barGraphItem))
            .attr("class", "horBar")
            .attr(
              "y",
              (this.props.data.dotGraphOffset || 3) +
                parseInt(idx, 10) * (this.barGraphsHeight + 1)
            )
            .attr("height", this.barGraphsHeight)
            .attr(
              "width",
              this.xDomain(barGraphItem.right) - this.xDomain(barGraphItem.left)
            )
            .attr("fill", barGraph.color || "#f00")
            .attr(
              "transform",
              "translate(" + this.margin.left + "," + this.margin.top + ")"
            );

          if (this.props.data.showInfoOnHover) {
            let barGraphHeight = this.barGraphsHeight;
            rect
              .on("mouseenter", function () {
                d3.select(this)
                  .attr("height", barGraphHeight + 2)
                  .attr("y", parseInt(d3.select(this).attr("y")) - 1);

                openGraphPopup(this);
              })
              .on("mouseleave", function () {
                d3.select(this)
                  .attr("height", barGraphHeight)
                  .attr("y", parseInt(d3.select(this).attr("y")) + 1);

                openGraphPopup(this, false);
              })
              .on("mousedown", function () {
                // onDotGraphClick(d3.select(this).attr('typeid'), d3.select(this).attr('itemid'));
              });
          }
        }
      }
    }
  }

  drawDotGraph() {
    if (this.dotGraphs) {
      let onDotGraphClick = this.onDotGraphClick;
      let openGraphPopup = this.openGraphPopup;
      for (let idx in this.dotGraphs) {
        if (!this.dotGraphs[idx] || !this.dotGraphs[idx].data) continue;
        let dotGraph = this.dotGraphs[idx];
        for (let jdx in dotGraph.data) {
          let dotGraphItem = dotGraph.data[jdx];
          this.svg
            .append("circle")
            .attr("cx", this.xDomain(dotGraphItem.time))
            .attr("clip-path", "url(#clip-" + this.uid + ")")
            .attr(
              "cy",
              this.margin.top +
                (this.props.data.dotGraphOffset || 10) +
                (this.barGraphs ? this.barGraphs.length : 5) *
                  (this.barGraphsHeight + 1)
            )
            .attr(
              "stroke",
              dotGraph.data[jdx].color || dotGraph.color || "#f00"
            )
            .attr(
              "transform",
              "translate(" + this.margin.left + "," + this.margin.top + ")"
            )
            .attr("stroke-width", 3)
            .attr("typeid", idx)
            .attr("itemid", jdx)
            .attr("item-data", JSON.stringify(dotGraphItem))
            .attr("r", 3)
            .attr("fill-opacity", 0)
            .on("mouseenter", function () {
              d3.select(this).attr("r", 7);
              openGraphPopup(this);
            })
            .on("mouseleave", function () {
              d3.select(this).attr("r", 3);
              openGraphPopup(this, false);
            })
            .on("mousedown", function () {
              onDotGraphClick(
                d3.select(this).attr("typeid"),
                d3.select(this).attr("itemid")
              );
            });
        }
      }
    }
  }

  initiateZoomRect() {
    if (this.svg) {
      this.mouseDown.rect = this.svg
        .append("rect")
        .attr("x", this.margin.left + this.mouseDown.startX)
        .attr("y", this.margin.top)
        .attr("class", "mousedownrect")
        .attr("fill", "rgba(255,0,0,0.3)")
        .attr("width", this.mouseDown.width)
        .attr("height", this.height);

      this.mouseDown.timeFrom = this.focus
        .append("text")
        .attr("x", 10)
        .attr("text-anchor", "start")
        .attr("y", 45)
        .attr("class", "mousedowntimefrom")
        .attr("font-size", 10)
        .attr("font-family", "gotham-b")
        .attr("fill", "#fff")
        .text("TIME FROM");

      this.mouseDown.timeTo = this.focus
        .append("text")
        .attr("x", 10)
        .attr("text-anchor", "start")
        .attr("class", "mousedowntimeto")
        .attr("y", 60)
        .attr("font-size", 10)
        .attr("font-family", "gotham-b")
        .attr("fill", "#fff")
        .text("TIME TO");
    }
  }

  drawLegends() {
    if (this.props.data.legends) {
      for (let idx in this.props.data.legends) {
        let legend = this.props.data.legends[idx];

        this["legend" + idx] = this.svg
          .append("g")
          .attr("class", "legendName")
          .attr(
            "transform",
            "translate(" +
              this.margin.left +
              "," +
              (this.margin.top + 2 + parseInt(idx, 10) * 12) +
              ")"
          );

        this["legendText" + idx] = this["legend" + idx]
          .append("text")
          .attr("x", 23)
          .attr("y", 8)
          .attr("font-size", 10)
          .attr("font-family", "gotham")
          .attr("fill", legend.color)
          .text(legend.name);

        this["legendColor" + idx] = this["legend" + idx]
          .append("rect")
          .attr("x", 10)
          .attr("y", 1)
          .attr("width", 8)
          .attr("height", 8)
          .attr("fill", legend.color);
      }
    }
  }

  addListenerToGraph() {
    if (this.svg) {
      const parentThis = this;
      this.svg
        .append("rect")
        .attr("class", "zoom")
        .attr("width", this.width)
        .attr("height", this.height)
        .attr(
          "transform",
          "translate(" + this.margin.left + "," + this.margin.top + ")"
        )
        .on("mousemove", (event) => {
          if (parentThis.state.tooltip) {
            const [x, y] = d3.pointer(event);
            parentThis.state.tooltip
              .style("left", x + "px")
              .style("top", y + "px");
          }
          parentThis.mouseOverTrigger(event);
        })
        .on("mouseout", (event) => {
          if (parentThis.state.tooltip) {
            parentThis.state.tooltip.style("opacity", 0);
          }
        })
        .on("mouseover", (event) => {
          if (parentThis.state.tooltip) {
            parentThis.state.tooltip.style("opacity", 1);
          }
        })
        .on("mousedown", this.mouseDownTrigger)
        .on("mouseup", this.mouseUpTrigger)
        .on("mouseleave", this.mouseLeaveTrigger)
        .on("click", this.mouseClickTrigger);
    }
  }

  /*
   *
   *   Listeners
   *
   * */

  onMouseOver(event) {
    if (!(event.source === "GOTO" && window.getSelectedGraph() === this.uid)) {
      this.setCurrentXY(event);
      this.setCurrentDataObject();
      this.setPointerLineAndText();
    }
    this.broadCastDataForOldGraphListeners();
  }

  onZoom(event) {
    for (let idx in this.line) {
      this.draw(
        this.getGraphData(idx),
        {
          zoomConfig: true,
          xDomainValue: event.xDomainValue,
        },
        null,
        this.graphKey
      );
    }
  }

  onPointerLock(event) {
    this.pointerLocked = event.status;
  }

  onSetTimeLine(event) {
    if (!this.xDomain) return;

    this.broadCastMouseOverEvent({
      offsetX: this.xDomain(event.time) + this.margin.left,
    });
  }

  /*
   *
   *   Helpers
   *
   * */

  onDotGraphClick = (typeID, itemID) => {
    let data = this.dotGraphs[typeID].data[itemID];
    if (data.alarmtype) {
      this.props.dispatch({
        type: actions.ADD_INTOAST,
        data: {
          name: data.alarmtype.split("_").join(" "),
          content: "Alarm Name : " + data.alarmtype,
          replace: true,
          createAt: Date.now(),
        },
      });
    }
  };

  toggleGraphLine(axis) {
    if (window.getSelectedGraph() !== this.uid) {
      window.setSelectedGraph(this.uid);
      return;
    }

    let config = this.getGraphConfig(axis);
    config.disabled = !config.disabled;
    this.onZoom(this.getDrawZoomConfig());
  }

  setCurrentXY(params) {
    this.mouseX = params.x * (this.width / params.width);
  }

  setCurrentDataObject() {
    let data;
    let time = 0;
    for (let idx in this.line) {
      this.currentDataObject[idx] = [];
      data = this.getGraphData(idx).data || [];
      let index;
      for (let jdx in data) {
        index =
          _.sortedIndexBy(
            data[jdx],
            { time: this.xDomain.invert(this.mouseX) },
            "time"
          ) - 1;
        if (!data[jdx][index]) continue;

        data[jdx][index].index = index;
        this.currentDataObject[idx].push(data[jdx][index] || {});
        time = (data[jdx][index] || {}).time || time;
      }
    }
    return time;
  }

  getCurrentDataObjects(index = false) {
    if (!index || !this.currentDataObject || !this.currentDataObject[index])
      return {};

    return this.currentDataObject[index];
  }

  getMultiLineName(axis, index) {
    if (!this.getGraphConfig(axis).multiLineNames) return index;
    return this.getGraphConfig(axis).multiLineNames[index];
  }

  getPointerLineText(axis) {
    let dataObjects = this.getCurrentDataObjects(axis);
    let text = this.getGraphName(axis);
    let value;
    if (dataObjects.length === 1 && !this.getGraphConfig(axis).multiLineNames) {
      value = this.getCurrentDataObjects(axis)[0].value
        ? this.getCurrentDataObjects(axis)[0].value
        : 0;
      value = parseFloat(value, 10);
      value = value % 1 == 0 ? parseInt(value, 10) : value.toFixed(2);
      let config = this.getGraphConfig(axis);
      if (config.getValue && config.getValue(value)) {
        text = config.getValue(value);
      } else {
        let extra = this.getGraphConfig(axis).unit;
        if (text === "Charge Type") {
          value =
            value === 3
              ? " Fast / Normal Charging"
              : value == 2
              ? " Fast Charging"
              : value == 1
              ? " Normal Charging"
              : value == 0
              ? " Not Charging"
              : "";
          text += ":" + value;
        } else text += ": " + value + (extra ? ": " + extra : "");
      }
    } else if (dataObjects.length > 0) {
      text += ": [";
      for (let index in dataObjects) {
        if (!this.getCurrentDataObjects(axis)[index]) continue;

        value = this.getCurrentDataObjects(axis)[index].value
          ? this.getCurrentDataObjects(axis)[index].value
          : 0;
        value = parseInt(value, 10);
        text +=
          this.getMultiLineName(axis, index) +
          ": " +
          value +
          " " +
          (this.getGraphConfig(axis).unit || "");
        if (parseInt(index) < dataObjects.length - 1) {
          text += ", ";
        }
      }
      text += "] ";
    }

    if (this.props.data.showTime && dataObjects.length) {
      text += " | " + moment(dataObjects[0].time).format(dateFormat + ":ss");
    }

    return text;
  }

  setPointerLineAndText() {
    if (this.focus) {
      if (this.pointerLine) {
        this.pointerLine.attr("x", this.mouseX);
      }
      for (let idx in this.line) {
        if (this["pointerText" + idx]) {
          this["pointerText" + idx].text(this.getPointerLineText(idx));
        }
      }
      if (this.props.data.pointerTime) {
        let time = moment(this.xDomain.invert(this.mouseX)).format(dateFormat);
        this.textTime.text(time);
      }
    }
  }

  isMouseDownValid(event) {
    if (!this.mouseDown) return false;

    if (this.mouseDown.x1) {
      if (
        this.mouseDown.x1 < event[graphOffsetKey + "X"] - this.margin.left &&
        event[graphOffsetKey + "X"] - this.margin.left - this.mouseDown.x1 > 5
      ) {
        return true;
      } else if (
        this.mouseDown.x1 > event[graphOffsetKey + "X"] - this.margin.left &&
        this.mouseDown.x1 - (event[graphOffsetKey + "X"] - this.margin.left) > 5
      ) {
        return true;
      }
    }
    return false;
  }

  calculateZoomValues(event) {
    if (!this.mouseDown) return;

    this.mouseDown.x2 = event[graphOffsetKey + "X"] - this.margin.left;
    if (this.mouseDown.x2 > this.mouseDown.x1) {
      this.mouseDown.startX = this.mouseDown.x1;
      this.mouseDown.endX = this.mouseDown.x2;
    } else {
      this.mouseDown.startX = this.mouseDown.x2;
      this.mouseDown.endX = this.mouseDown.x1;
    }
    this.mouseDown.width = this.mouseDown.endX - this.mouseDown.startX;
  }

  updateZoomRect() {
    this.mouseDown.rect
      .attr("x", this.margin.left + this.mouseDown.startX)
      .attr("width", this.mouseDown.width);

    this.mouseDown.timeFrom.text(
      "Start time: " +
        moment(this.xDomain.invert(this.mouseDown.startX)).format(dateFormat)
    );
    this.mouseDown.timeTo.text(
      "End time: " +
        moment(this.xDomain.invert(this.mouseDown.endX)).format(dateFormat)
    );
  }

  clearZoomRect() {
    d3.select(".mousedownrect").remove();
    d3.select(".mousedowntimefrom").remove();
    d3.select(".mousedowntimeto").remove();
    if (this.mouseDown) {
      delete this.mouseDown.rect;
      delete this.mouseDown.timeFrom;
      delete this.mouseDown.timeTo;
    }
  }

  togglePointerLock(status = null) {
    this.broadCastPointerLockEvent(
      status !== null ? status : !this.pointerLocked
    );
    window.setSelectedGraph(this.uid);
  }

  getData(processData) {
    let processedData = null;
    let headers = null;

    const getKeyName = (index, config, force) => {
      if (force) {
        return (
          config.name +
          " [" +
          (config.multiLineNames ? config.multiLineNames[index] : index) +
          "]"
        );
      } else {
        return config.multiLineNames
          ? config.name + " [" + config.multiLineNames[index] + "]"
          : config.name;
      }
    };

    if (processData) {
      processedData = [];
      let dataByTime = {};
      let keyArray = [];
      let config;
      let name;
      let dataObject;
      let item;
      let data;
      headers = ["Date"];
      for (let axis in this.props.lines) {
        config = this.props.lines[axis];
        data = this.getGraphData(axis).data || [];
        for (let jdx in data) {
          name = getKeyName(jdx, config, data.length > 1);
          if (headers.indexOf(name) === -1) {
            headers.push(name);
          }
        }
      }

      for (let axis in this.props.lines) {
        config = this.props.lines[axis];
        data = this.getGraphData(axis).data || [];
        for (let jdx in data) {
          name = getKeyName(jdx, config, data.length > 1);
          dataObject = data[jdx];
          for (let kdx in dataObject) {
            item = dataObject[kdx];
            item.time = parseInt(item.time, 10);
            if (!(item.time in dataByTime)) {
              dataByTime[item.time] = {};
              for (let qdx in headers) {
                dataByTime[item.time][headers[qdx]] = "-";
              }
              dataByTime[item.time].Date = item.time;
              keyArray.push(parseInt(item.time, 10));
            }
            // dataByTime[item.time][name] = item.value + ' ' + (config.unit || '');
            dataByTime[item.time][name] = item.value;
          }
        }
      }
      keyArray = keyArray.sort((a, b) => {
        return a - b;
      });
      for (let idx in keyArray) {
        dataByTime[keyArray[idx]].Date = moment(
          dataByTime[keyArray[idx]].Date
        ).format(dateFormatWithSec);
        processedData.push(dataByTime[keyArray[idx]]);
      }
    }
    return {
      data: this.data,
      config: this.props.data,
      processedData,
      headers,
    };
  }

  /*
   *
   *   Events
   *
   * */

  onKeyDown(e) {
    if (
      !this.props.reportWindow.visible ||
      this.state.noData ||
      this.state.busy
    )
      return;

    switch (e.keyCode) {
      case 37:
        this.broadCastGotoEvent({ action: -1 });
        break;

      case 39:
        this.broadCastGotoEvent({ action: 1 });
        break;

      default:
    }
  }

  mouseOverTrigger(event) {
    if (!event) return;

    if (this.isMouseDownValid(event)) {
      this.calculateZoomValues(event);
      if (!this.mouseDown.rect) {
        this.initiateZoomRect();
      } else {
        this.updateZoomRect();
      }
    } else {
      this.clearZoomRect();
    }
    if (!this.mouseDown && !this.pointerLocked) {
      this.broadCastMouseOverEvent(event);
    }
  }

  mouseDownTrigger = (event) => {
    this.mouseDown = {
      button:event.button,
      x1: event[graphOffsetKey+'X'] - this.margin.left,
    };
  };

  mouseUpTrigger = (event) => {
    if(!event || !this.mouseDown) return;
    this.broadCastMouseOverEvent(event);
    if(this.isMouseDownValid(event) || this.mouseDown.button === 2) {
        this.broadCastZoom(this.mouseDown.button === 2);
    }
    this.clearZoomRect();
    this.mouseDown = null;
  };

  mouseLeaveTrigger = (event) => {
    this.mouseDown = null;
    this.mouseDownX = null;
    this.mouseDownY = null;
  };

  mouseClickTrigger = (event) => {
    if (this.props.onClick) {
      this.props.onClick(event);
    }
  };

  /*
   *
   *   Broadcast
   *
   * */

  broadCastPointerLockEvent(status) {
    window.callInGraph2Listeners(
      "pointerlock",
      { status },
      this.props.data.graphSetName
    );
  }

  broadCastMouseOverEvent(event) {
    let graphOffset = graphOffsetKey;
    if (event[graphOffsetKey + "X"] == undefined) {
      if (graphOffsetKey == "layer") {
        graphOffset = "offset";
      } else {
        graphOffset = "layer";
      }
    }
    window.callInGraph2Listeners(
      "mouseover",
      {
        x: event[graphOffset + "X"] - this.margin.left,
        source: event.source,
        key: this.props.data.key,
        time: this.xDomain.invert(event[graphOffset + "X"] - this.margin.left),
        width: this.width,
      },
      this.props.data.graphSetName
    );
  }

  broadCastZoom(clearZoom) {
    window.callInGraph2Listeners(
      "zoom",
      {
        xDomainValue: clearZoom
          ? this.getDrawConfig().xDomainValue
          : [
              moment(this.xDomain.invert(this.mouseDown.startX)).unix() * 1000,
              moment(this.xDomain.invert(this.mouseDown.endX)).unix() * 1000,
            ],
        dispatch: this.props.dispatch,
      },
      this.props.data.graphSetName
    );
  }

  broadCastDataForOldGraphListeners() {
    if (
      this.xDomain &&
      !this.unmounted &&
      isGraphVisible(this.props.data, this.vehicle)
    ) {
      let broadCastData = {
        time: moment(this.xDomain.invert(this.mouseX)),
      };
      let value;
      for (let axis in this.line) {
        let dataObjects = this.getCurrentDataObjects(axis);
        if (dataObjects.length === 1) {
          value = dataObjects[0].value;
        } else {
          value = dataObjects.map((i) => {
            return i.value;
          });
        }
      }
      broadCastData[this.props.data.key] = value;
      window.callGraphListeners("graphBroadcast", broadCastData);
    }
  }

  broadCastGotoEvent(event) {
    if (window.getSelectedGraph() === this.uid) {
      let time = 9999999999999999999999;
      for (let axis in this.currentDataObject) {
        let data = this.getGraphData(axis).data || [];
        for (let jdx in this.currentDataObject[axis]) {
          let index = this.currentDataObject[axis][jdx].index;
          if (data && data[jdx] && data[jdx][index + event.action]) {
            index = index + event.action;
            data[jdx][index].index = index;
            this.currentDataObject[axis][jdx] = data[jdx][index];
            if (data[jdx][index].time < time) {
              time = data[jdx][index].time;
            }
          }
        }
      }
      if (time < 9999999999999999999999) {
        this.mouseX = this.xDomain(time);
        this.setPointerLineAndText();
        this.broadCastMouseOverEvent({
          offsetX: this.xDomain(time) + this.margin.left,
          source: "GOTO",
        });
      }
    }
  }

  /*
   *
   *   MISC
   *
   * */

  onVehicleChange = () => {
    if (!this.mounted) return;
    this.vehicles = window.selectedVehicles;
    if (this.vehicles[0] && this.vehicles[0].data) {
      this.vehicle = this.vehicles[0].data;
    }
    this.setNoData(true);
    this.broadCastZoom(true);
  };

  getMainContainerStyle = () => {
    return this.props.data.background
      ? {
          background: this.props.data.background,
        }
      : {};
  };

  /*
   *
   *   Render
   *
   * */

  renderZoomBlocker() {
    return <div className="zoomBlocker"></div>;
  }

  renderNoDataBox() {
    let name = "";
    let fueltype =
      window.selectedVehicles &&
      window.selectedVehicles[0] &&
      window.selectedVehicles[0].data.vehicleModel.fueltype;
    if (this.props.data.config.length) {
      if (this.props.data.config.length === 1) {
        name = this.props.data.config[0].name;
        if (name === "Engine Speed" && fueltype === "EV") {
          name = "RPM";
        }
      } else if (this.props.data.config.length > 1) {
        for (let idx in this.props.data.config) {
          name = name + ", " + this.props.data.config[idx].name;
          name = name.replace(/^,|,$/g, "");
        }
      }
      //console.log("inside if",this.props.data.config[0])
      // console.log("inside  if",this.props)
    }
    return this.state.noData ? (
      <div className="ig-noData">
        <span>{name}</span>
        <span> No Data </span>
      </div>
    ) : null;
  }

  renderBusyBox() {
    return this.state.busy ? (
      <div className="ig-busy">
        <span className="igb-spinner"></span>
      </div>
    ) : null;
  }

  renderSVG() {
    return (
      <svg
        ref="svg"
        width={this.props.config.width}
        height={this.props.config.height}
      ></svg>
    );
  }

  renderPopup() {
    return (
      <div className="ig-popup" style={this.state.popup.style} ref="popup">
        <div className="igp-heading">{this.state.popup.name}</div>
        <div className="igp-data">
          <table>
            <tbody>
              {this.state.popup.content
                ? this.state.popup.content.map((item, index) => {
                    return (
                      <tr className="igpd-item" key={index}>
                        <td className="igpdi-name">{item.key}</td>
                        <td className="igpdi-data">{item.value}</td>
                      </tr>
                    );
                  })
                : ""}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div
        className={"InGraph " + (this.props.data.graphSetName || "")}
        onMouseUp={this.containerMouseUp}
        style={this.getMainContainerStyle()}
        ref="container"
        // ref={this.props.forwardedRef}
      >
        {this.renderNoDataBox()}
        {this.renderZoomBlocker()}
        {this.renderBusyBox()}
        {this.renderSVG()}
        {this.renderPopup()}
      </div>
    );
  }
}

const MapPropsToState = (state) => {
  return {
    reportWindow: state.reportWindow,
  };
};
const InGraph = React.forwardRef((props, ref) => {
    return <InGraph2 {...props} ref={ref} />;
  });

export default connect(MapPropsToState, null, null, { forwardRef: true })(InGraph);
